import React from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { Autocomplete, Checkbox, createFilterOptions, FormControl, MenuItem, TextField, Tooltip } from '@mui/material';
import { IDropDownOptions } from './AppSelectList';
import {
    LockOutlined
} from '@mui/icons-material';

export interface IDropDownDisabledOptions extends IDropDownOptions {
    isDisabled: boolean,
    disabledMessage: string
}

interface IProps extends UseControllerProps {
    label: string;
    options: IDropDownDisabledOptions[];
    size?: "small" | "medium";
    disabled?: boolean;
    onChange?: (value: any) => void;
    limit?: number;
    readOnly?: boolean;
    freeSolo?: boolean;
    includeSelectAll?: boolean;
}

const AppMultiSelectWithDisabledEntries = (props: IProps) => {
    const { fieldState, field } = useController({ ...props, defaultValue: [] });
    const selectAllOption = { id: 'selectAll', value: 'Select all' };
    const allOptions = [selectAllOption, ...props.options];
    const selectedOptions = props.options.filter(option => (field.value || []).includes(option.id));

    const filterOptions: any = createFilterOptions<any>({
        matchFrom: 'any',
        stringify: (option) => option.value,
        limit: props.limit === undefined ? 20 : props.limit,
    });

    return (
        <FormControl fullWidth error={!!fieldState.error}>
            <Autocomplete
                {...props}
                {...field}
                value={selectedOptions}
                onChange={(event, value) => {
                    const values = value.some(option => option.id === selectAllOption.id)
                        ? props.options.filter(option => !option.isDisabled).map(option => option.id)
                        : value.map((item: IDropDownDisabledOptions) => item.id);

                    field.onChange(values);
                    if (props.onChange) {
                        if (values) {
                            props.onChange(values);
                        }
                    }
                }}
                multiple
                disableCloseOnSelect
                options={props.includeSelectAll ? allOptions : props.options}
                filterOptions={filterOptions}
                getOptionLabel={option => option.value}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderOption={(props, option) => {
                    return (
                        option.isDisabled ?
                            <Tooltip title={option.disabledMessage}>
                                <div>
                                    <MenuItem key={option.id} value={option.id} {...props} disabled={option.isDisabled}>
                                        <div style={{ display: 'inline-block', padding: '9px' }}>
                                            <LockOutlined style={{ width: 20, height: 20 }} />
                                        </div>
                                        {option.value}
                                    </MenuItem>
                                </div>
                            </Tooltip>
                            :
                            <MenuItem key={option.id} value={option.id} {...props}>
                                <Checkbox checked={field.value.includes(option.id)} />
                                {option.value}
                            </MenuItem>

                    )
                }}
                renderInput={
                    (params) => <TextField
                        {...params}
                        fullWidth
                        label={props.label}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                        variant="outlined"
                        size={props.size}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                }
                disabled={props.disabled}
            />
        </FormControl>)
}

export default AppMultiSelectWithDisabledEntries